import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  StateStatus,
} from '../../../redux/utils/common';
import NavigationConfig from '../../../navigation/config';
// import ModalActions from '../../reducers/gl_modal_reducer/actions';
// import { ModalIDs } from '../gl_modal_reducer/types';
import * as VatReturnDetailEndpoints from '../../../services/api/vatreturn_detail';
import * as VatReturnListService from '../../../services/api/vatreturn_list';
import * as DateUtils from '../../../utils/dates';

interface FetchVatReturnDetailInput {
  id: number;
}

class FetchVatReturnDetail implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VATRETURN_DETAIL,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VATRETURN_DETAIL,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VATRETURN_DETAIL,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchVatReturnDetailInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnDetailEndpoints.fetchVatReturnDetail(
          payload.id
        );

        let details = response.data;
        let supplies_from_member_state_of_identification =
          response.data.supplies_from_member_state_of_identification;
        let supplies_from_fixed_establishments =
          response.data.supplies_from_fixed_establishments;
        let vat_corrections = response.data.corrections_to_vat_returns;
        let mscon = response.data.mscon;

        delete details.supplies_from_member_state_of_identification;
        delete details.supplies_from_fixed_establishments;
        delete details.vat_corrections;
        delete details.mscon;

        dispatch(
          this.onSuccess({
            data: details,
            supplies_from_member_state_of_identification,
            supplies_from_fixed_establishments,
            vat_corrections,
            mscon,
          })
        );
      } catch (error: any) {
        // console.log('FetchVatReturnDetailInput Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface FetchCountriesWithVatRateInput {
  start_date?: string;
  end_date?: string;
  year?: number;
  quarter_id?: number;
  type: 'QUARTER' | 'DATE';
  excludeCyprus: boolean;
}
class FetchCountriesWithVatRate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchCountriesWithVatRateInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = null;
        if (payload.type === 'QUARTER') {
          response =
            await VatReturnDetailEndpoints.fetchCountriesWithVatRateByQuarter({
              quarter_id: payload.quarter_id ?? 0,
              year: payload.year ?? 0,
              excludeCyprus: payload.excludeCyprus,
            });
        } else {
          response =
            await VatReturnDetailEndpoints.fetchCountriesWithVatRateByDate({
              start_date: payload.start_date
                ? payload.start_date
                : DateUtils.DateInQueryFormat(new Date()),
              end_date: payload.end_date
                ? payload.end_date
                : DateUtils.DateInQueryFormat(new Date()),
              excludeCyprus: payload.excludeCyprus,
            });
        }
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchCountriesWithVatRateInput Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface ISuppliesFromMemberStateOfIdentification {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
}

interface ISuppliesFromMemberStateOfIdentificationInput {
  items: Array<ISuppliesFromMemberStateOfIdentification>;
  total_vat_amount_payable_services: number;
  total_vat_amount_payable_goods: number;
}
class SetSuppliesFromMemberStateOfIdentification implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_SUPPLIES_FROM_MEMBER_STATE_OF_IDENTIFICATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: ISuppliesFromMemberStateOfIdentificationInput): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

interface ISuppliesFromFixedEstablishments {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
  fixed_establishment: number;
}

interface ISuppliesFromFixedEstablishmentsInput {
  items: Array<ISuppliesFromFixedEstablishments>;
  total_vat_amount_payable_services: number;
  total_vat_amount_payable_goods: number;
}
class SetSuppliesFromFixedEstablishments implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_SUPPLIES_FROM_FIXED_ESTABLISHMENTS,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: ISuppliesFromFixedEstablishmentsInput): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

// SET MSCON
interface IMscon {
  vat_return_version_id: number;
  country_id: number;
  country: string;
  grand_total: number;
  total_msid_goods: number;
  total_msid_services: number;
  total_msest_goods: number;
  total_msest_services: number;
  due_balance: number;
  total_correction: number;
  total_amount_due: number;
}
class SetMscon implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MSCON,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: Array<IMscon>): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

//Fetch fixed establishments by vat return id
interface FixedEstablihsmentByVatReturnInput {
  vat_return_id: number;
}
class FetchFixedEstablishmentsByVatReturnId implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_FIXED_ESTABLISHMENTS_OF_VAT_RETURN,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_FIXED_ESTABLISHMENTS_OF_VAT_RETURN,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_FIXED_ESTABLISHMENTS_OF_VAT_RETURN,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FixedEstablihsmentByVatReturnInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await VatReturnDetailEndpoints.fetchFixedEstablishmentsByVatReturnId({
            vat_return_id: payload.vat_return_id,
          });
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FixedEstablihsmentByVatReturnInput Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

// TEMPORARY SAVE VAT RETURN
interface TemporarySaveVatReturnInput {
  vat_return_id: number;
  payload: any;
}
class TemporarySaveVatReturn implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.TEMPORARY_SAVE_VAT_RETURN,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.TEMPORARY_SAVE_VAT_RETURN,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.TEMPORARY_SAVE_VAT_RETURN,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: TemporarySaveVatReturnInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnDetailEndpoints.temporarySaveVatReturn({
          vat_return_id: payload.vat_return_id,
          payload: payload.payload,
        });
        dispatch(this.onSuccess(response.data));
        dispatch(
          new FetchVatReturnDetail().action({ id: payload.vat_return_id })
        );
      } catch (error: any) {
        // console.log('TemporarySaveVatReturn Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

// FINAL SAVE VAT RETURN
interface FinalSaveVatReturnInput {
  vat_return_id: number;
  payload: any;
  history: any;
}
class FinalSaveVatReturn implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.FINAL_SAVE_VAT_RETURN,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.FINAL_SAVE_VAT_RETURN,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.FINAL_SAVE_VAT_RETURN,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FinalSaveVatReturnInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnDetailEndpoints.finalSaveVatReturn({
          vat_return_id: payload.vat_return_id,
          payload: payload.payload,
        });
        dispatch(this.onSuccess(response.data));
        payload.history.push(
          NavigationConfig.vatReturnDetailPage(
            `${payload.vat_return_id}`,
            'view'
          ).path
        );
      } catch (error: any) {
        // console.log('FinalSaveVatReturn Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

// SUBMIT NILL
class NilSaveVatReturn implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SUBMIT_NIL_VAT_RETURN,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SUBMIT_NIL_VAT_RETURN,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SUBMIT_NIL_VAT_RETURN,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FinalSaveVatReturnInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnDetailEndpoints.nilSaveVatReturn({
          vat_return_id: payload.vat_return_id,
          payload: payload.payload,
        });
        dispatch(this.onSuccess(response.data));
        payload.history.push(
          NavigationConfig.vatReturnDetailPage(
            `${payload.vat_return_id}`,
            'view'
          ).path
        );
      } catch (error: any) {
        // console.log('NilSaveVatReturn Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchQuarters implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_QUARTERS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_QUARTERS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_QUARTERS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchQuarters();

        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchQuarters Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMonthQuarters implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MONTH_QUARTERS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MONTH_QUARTERS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MONTH_QUARTERS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchMonthQuarters();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch Month Quarter Types Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class SetVatCorrections implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VAT_CORRECTIONS,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: any): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

interface IFetchCorrectionsCountriesPayload {
  vat_return_id: number;
  year: number;
  quarter_id: number;
}
class FetchCorrectionsCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CORRECTIONS_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CORRECTIONS_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CORRECTIONS_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchCorrectionsCountriesPayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchCorrectionsCountries(
          payload.vat_return_id,
          payload.year,
          payload.quarter_id
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchCorrectionsCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class ResetReducer implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }

  onSuccess(): IAction {
    return {
      type: Types.RESET_REDUCER,
      status: StateStatus.Success,
      data: null,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

class EmptyCorrectionsCountries implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_CORRECTIONS_COUNTRIES,
      status: StateStatus.Success,
      data: [],
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

export interface FetchFEstCountriesWithVatRateInput {
  start_date?: string;
  end_date?: string;
  year?: number;
  quarter_id?: number;
  type: 'QUARTER' | 'DATE';
  exclude?: Array<number>;
  excludeCyprus: boolean;
}
class FetchFEstCountriesWithVatRate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE_FEST,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE_FEST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE_FEST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchFEstCountriesWithVatRateInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = null;
        if (payload.type === 'QUARTER') {
          response =
            await VatReturnDetailEndpoints.fetchCountriesWithVatRateByQuarter({
              quarter_id: payload.quarter_id ?? 0,
              year: payload.year ?? 0,
              excludeCyprus: payload.excludeCyprus,
              exclude: payload.exclude,
            });
        } else {
          response =
            await VatReturnDetailEndpoints.fetchCountriesWithVatRateByDate({
              start_date: payload.start_date
                ? payload.start_date
                : DateUtils.DateInQueryFormat(new Date()),
              end_date: payload.end_date
                ? payload.end_date
                : DateUtils.DateInQueryFormat(new Date()),
              excludeCyprus: payload.excludeCyprus,
              exclude: payload.exclude,
            });
        }
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchCountriesWithVatRateInput Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class EmtpyFEstCountriesWithVatRate implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }

  onSuccess(): IAction {
    return {
      type: Types.SET_COUNTRIES_WITH_VAT_RATE_FEST,
      status: StateStatus.Success,
      data: [],
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

export default {
  fetchVatReturnDetailAction: (payload: FetchVatReturnDetailInput) =>
    new FetchVatReturnDetail().action(payload),
  FetchCountriesWithVatRateAction: (payload: FetchCountriesWithVatRateInput) =>
    new FetchCountriesWithVatRate().action(payload),
  setSuppliesFromMemberStateOfIdentificationAction: (
    payload: ISuppliesFromMemberStateOfIdentificationInput
  ) => new SetSuppliesFromMemberStateOfIdentification().action(payload),
  setSuppliesFromFixedEstablishmentsAction: (
    payload: ISuppliesFromFixedEstablishmentsInput
  ) => new SetSuppliesFromFixedEstablishments().action(payload),
  setFixedEstablishmentsByVatReturn: (
    payload: FixedEstablihsmentByVatReturnInput
  ) => new FetchFixedEstablishmentsByVatReturnId().action(payload),
  temporarySaveVatReturnAction: (payload: TemporarySaveVatReturnInput) =>
    new TemporarySaveVatReturn().action(payload),
  finalSaveVatReturnAction: (payload: FinalSaveVatReturnInput) =>
    new FinalSaveVatReturn().action(payload),
  nilSaveVatReturnAction: (payload: FinalSaveVatReturnInput) =>
    new NilSaveVatReturn().action(payload),
  fetchQuarters: () => new FetchQuarters().action(),
  fetchMonthQuarters: () => new FetchMonthQuarters().action(),
  setVatCorrections: (payload: any) => new SetVatCorrections().action(payload),
  fetchCorrectionsCountriesAction: (
    payload: IFetchCorrectionsCountriesPayload
  ) => new FetchCorrectionsCountries().action(payload),
  emptyCorrectionsCountriesAction: () =>
    new EmptyCorrectionsCountries().action(),
  setMsconAction: (payload: Array<IMscon>) => new SetMscon().action(payload),
  resetReducerAction: () => new ResetReducer().action(),
  fetchFEstCountriesWithVatRateAction: (
    payload: FetchFEstCountriesWithVatRateInput
  ) => new FetchFEstCountriesWithVatRate().action(payload),
  emptyFEstCountriesWithVatRateAction: () =>
    new EmtpyFEstCountriesWithVatRate().action(),
};
